/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessEntry } from './AccessEntry';
import {
    AccessEntryFromJSON,
    AccessEntryFromJSONTyped,
    AccessEntryToJSON,
} from './AccessEntry';

/**
 * A visit as shown on the agent dashboard.
 * @export
 * @interface AgentDashboardVisit
 */
export interface AgentDashboardVisit {
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    visitId: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    visitType?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    listingAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    formStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof AgentDashboardVisit
     */
    dueBy?: Date;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    visitFormId?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDashboardVisit
     */
    formLink?: string;
    /**
     * 
     * @type {Array<AccessEntry>}
     * @memberof AgentDashboardVisit
     */
    accessEntries?: Array<AccessEntry>;
    /**
     * 
     * @type {Date}
     * @memberof AgentDashboardVisit
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the AgentDashboardVisit interface.
 */
export function instanceOfAgentDashboardVisit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "visitId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;

    return isInstance;
}

export function AgentDashboardVisitFromJSON(json: any): AgentDashboardVisit {
    return AgentDashboardVisitFromJSONTyped(json, false);
}

export function AgentDashboardVisitFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentDashboardVisit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visitId': json['visit_id'],
        'visitType': !exists(json, 'visit_type') ? undefined : json['visit_type'],
        'listingAddress': !exists(json, 'listing_address') ? undefined : json['listing_address'],
        'status': json['status'],
        'formStatus': !exists(json, 'form_status') ? undefined : json['form_status'],
        'dueBy': !exists(json, 'due_by') ? undefined : (new Date(json['due_by'])),
        'visitFormId': !exists(json, 'visit_form_id') ? undefined : json['visit_form_id'],
        'formLink': !exists(json, 'form_link') ? undefined : json['form_link'],
        'accessEntries': !exists(json, 'access_entries') ? undefined : ((json['access_entries'] as Array<any>).map(AccessEntryFromJSON)),
        'createdAt': (new Date(json['created_at'])),
    };
}

export function AgentDashboardVisitToJSON(value?: AgentDashboardVisit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visit_id': value.visitId,
        'visit_type': value.visitType,
        'listing_address': value.listingAddress,
        'status': value.status,
        'form_status': value.formStatus,
        'due_by': value.dueBy === undefined ? undefined : (value.dueBy.toISOString()),
        'visit_form_id': value.visitFormId,
        'form_link': value.formLink,
        'access_entries': value.accessEntries === undefined ? undefined : ((value.accessEntries as Array<any>).map(AccessEntryToJSON)),
        'created_at': (value.createdAt.toISOString()),
    };
}

